// extracted by mini-css-extract-plugin
module.exports = {"icon":"HelpDropdown_icon__36lHI","container":"HelpDropdown_container__1JDKh"};